export type BankConnectionProvider = "STRIPE_FINANCIAL_CONNECTIONS" | "PLAID" | "MANUAL";

const PROVIDER_LABELS: Record<BankConnectionProvider, string> = {
  STRIPE_FINANCIAL_CONNECTIONS: "Stripe Financial Connections",
  PLAID: "Plaid",
  MANUAL: "Manual entry"
};

export function bankConnectionProviderLabel(provider?: BankConnectionProvider | null) {
  if (!provider) return null;
  return PROVIDER_LABELS[provider];
}

export function isLinkedBankConnectionProvider(provider?: BankConnectionProvider | null) {
  return provider === "STRIPE_FINANCIAL_CONNECTIONS" || provider === "PLAID";
}
